import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { NavLink } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import classnames from 'classnames';

import { PATH_APPLICATIONS } from 'app-constants';
import AppsIcon from '@material-ui/icons/Apps';

const useStyles = makeStyles((theme) => {
  const spaceRight = theme.spacing.unit * 2;
  return {
    root: {
      textDecoration: 'none',
      position: 'relative',
      overflow: 'visible'
    },
    collapsed: {
      maxHeight: 42,
      '& $listIcon': {
        marginLeft: 5
      }
    },
    show: {
      opacity: 1,
      transition: theme.transitions.create('opacity', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    hidden: {
      opacity: 0
    },
    textWrap: {
      overflowWrap: 'break-word',
      whiteSpace: 'normal'
    },
    listIcon: {},
    icon: {
      position: 'absolute',
      top: '50%',
      right: spaceRight,
      transform: 'translateY(-50%)',
      color: theme.palette.text.primary
    }
  };
});

export default function SelectApp(props) {
  const classes = useStyles();
  const { app, collapse, listItemClass } = props;
  const { appId, name } = app;

  return (
    <ListItem
      className={classnames(listItemClass, classes.root, {
        [classes.collapsed]: collapse
      })}
      activeClassName="selected"
      component={NavLink}
      data-testid="select-application"
      to={{
        pathname: PATH_APPLICATIONS
      }}
    >
      {collapse && (
        <ListItemIcon data-testid="app-icon" className={classes.listIcon}>
          <AppsIcon />
        </ListItemIcon>
      )}
      <ListItemText
        className={classnames({
          [classes.hidden]: collapse,
          [classes.show]: !collapse
        })}
        data-testid="list-item-text"
      >
        <Typography variant="caption" gutterBottom>
          Application
        </Typography>
        <Typography variant="h6" gutterBottom className={classes.textWrap}>
          {name || 'Select Application'}
        </Typography>
        <Typography variant="caption" gutterBottom className={classes.textWrap}>
          {appId || '-'}
        </Typography>
        <ChevronRight className={classes.icon} />
      </ListItemText>
    </ListItem>
  );
}
